import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageTitle, Panel, Field, inputCls, btnPrimary, btnGhost } from "./ui";

const MfaPanel = () => {
  const { user, refresh } = useAuth();
  const [cid, setCid] = useState(null);
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const call = async (fn, msg) => {
    try { await fn(); if (msg) toast.success(msg); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Panel title="Dvofaktorska prijava (kod emailom)">
      <p className="mb-3 text-sm" data-testid="mfa-status">Status: {user.mfa_enabled ? "uključeno" : "isključeno (preporučeno za privilegovane račune)"}</p>
      {!user.mfa_enabled && !cid && <button onClick={() => call(async () => setCid((await api.post("/auth/mfa/setup-request")).data.challenge_id), "Kod je poslan na vaš email")} className={btnGhost} data-testid="mfa-enable-start">Uključi MFA</button>}
      {!user.mfa_enabled && cid && <div className="flex gap-2"><input value={code} maxLength={6} onChange={(e) => setCode(e.target.value)} placeholder="6-cifreni kod" className={inputCls} data-testid="mfa-enable-code" /><button onClick={() => call(async () => { await api.post("/auth/mfa/enable", { challenge_id: cid, code }); await refresh(); setCid(null); }, "MFA uključen")} className={btnPrimary} data-testid="mfa-enable-confirm">Potvrdi</button></div>}
      {user.mfa_enabled && <div className="flex gap-2"><input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Lozinka" className={inputCls} data-testid="mfa-disable-password" /><button onClick={() => call(async () => { await api.post("/auth/mfa/disable", { password: pw }); await refresh(); }, "MFA isključen")} className={btnGhost} data-testid="mfa-disable">Isključi</button></div>}
    </Panel>
  );
};

export default function Profile() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [p, setP] = useState({ name: user.name, bio: user.bio || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const saveProfile = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/auth/profile", p);
      setUser(data);
      toast.success("Profil sačuvan");
    } catch (err) { toast.error(errMsg(err)); }
  };
  const changePw = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", pw);
      setPw({ current_password: "", new_password: "" });
      toast.success("Lozinka promijenjena. Ostale sesije su odjavljene.");
    } catch (err) { toast.error(errMsg(err)); }
  };
  const logoutAll = async () => {
    await api.post("/auth/logout-all");
    setUser(false);
    nav("/admin/login");
  };
  return (
    <div className="max-w-3xl space-y-6" data-testid="admin-profile-page">
      <PageTitle title="Moj profil" sub={`${user.email} · ${user.roles.join(", ")}`} />
      <form onSubmit={saveProfile}>
        <Panel title="Javni profil autora">
          <div className="space-y-4">
            <Field label="Ime i prezime" htmlFor="p-name"><input id="p-name" required value={p.name} onChange={(e) => setP({ ...p, name: e.target.value })} className={inputCls} data-testid="profile-name-input" /></Field>
            <Field label="Kratka biografija (prikazuje se uz članke)" htmlFor="p-bio"><textarea id="p-bio" rows={3} maxLength={600} value={p.bio} onChange={(e) => setP({ ...p, bio: e.target.value })} className={inputCls} data-testid="profile-bio-input" /></Field>
            <button className={btnPrimary} data-testid="profile-save-button">Sačuvaj</button>
          </div>
        </Panel>
      </form>
      <form onSubmit={changePw}>
        <Panel title="Promjena lozinke">
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Trenutna lozinka" htmlFor="p-cur"><input id="p-cur" type="password" autoComplete="current-password" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className={inputCls} data-testid="profile-current-password" /></Field>
            <Field label="Nova lozinka" htmlFor="p-new" hint="Najmanje 12 znakova, slova i brojevi."><input id="p-new" type="password" autoComplete="new-password" required value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className={inputCls} data-testid="profile-new-password" /></Field>
          </div>
          <button className={`${btnPrimary} mt-4`} data-testid="profile-change-password-button">Promijeni lozinku</button>
        </Panel>
      </form>
      <MfaPanel />
      <Panel title="Sesije">
        <button onClick={logoutAll} className={btnGhost} data-testid="logout-all-button">Odjavi sve uređaje</button>
      </Panel>
    </div>
  );
}
